<template>

        <conteudo :ajax="false">
                
                <h1 class='f3'> {{ $t('Cálculo de Ritmo') }}  </h1>

                 <div class="form-group">
                    <label class="step o-40" for="exampleFormControlSelect1"> <b>1</b>  {{ $t('Selecione a Prova') }} </label>

                    <div class='step-content' style="display:none">
                        <race-selector>
                        </race-selector>
                    </div>
                </div>
                
              


                <div class="form-group">
                    <label class="step o-40" for="exampleFormControlSelect1"> <b>2</b>  {{ $t('Escolha um horário') }} </label>

                     <div class='step-content'>
                    <select @change="calcula" class="form-control" id="exampleFormControlSelect1">
                        <option v-for="start in startTimeOptions" :value="start.value">{{start.text}}</option>
                    </select>
                    </div>
                </div>
                




                <div class="form-group">
                    <label class="step o-40" for="exampleFormControlSelect1"> <b>3</b> - {{ $t('Trechos') }}</label>

                     <div class='step-content'>
                    <div v-for="(trecho,index) in checkpoints" class="trecho-linha row ritmo" >
                       
                         <div class="col-12 col-md-6">
                             <b> {{ $t('Trecho') }} {{index+1}} - <small> &emsp;{{trecho.properties.distance.toFixed(2)}}  km</small> </b> 
                        </div>
                        
                        <div class="col-12 col-md-6">
                                
                                <input @change="calcula" v-mask="'#h##m'" class="col-12 input-mini trecho-ritmo" 
                                        :data-abertura="trecho.properties.abertura" 
                                        :data-fechamento="trecho.properties.fechamento" 
                                        :data-dist="trecho.properties.distance" 
                                        id="prependedInput" type="text" placeholder="0h00m">
                         </div>

                         <div class="info"></div>
                    </div>
                    </div>
                    
                </div>

                <div class='row'>
                    <div class='col-12'> 
                        <h3  style='font-size:14px;text-align:left'>
                            {{ $t('Tempo total') }}: <div style='font-size:18px;' id='tempototal'> 0h</div>
                        </h3>
                    </div> 
                    <div class='col-6'>
                        <h3  style='font-size:12px;text-align:left'>
                             {{ $t('Média do Ritmo') }}:<div style='font-size:18px;' id='pacemedio'> 0 min/h</div>
                        </h3>
                    </div>
                </div>

        </conteudo>

</template>


<script>
    import Conteudo from './conteudo.vue'

    export default {
        data(){
            return {
                mudando:false
            }
        },

        components: {
            'conteudo':Conteudo
        },

        computed:{
            checkpoints:function(){
                return this.$store.getters.checkpointsCourses;
            },
            
            currentRace:function(){
                return this.$store.getters.currentRace;
            },

            currentCheckpoint:function(){
                return this.checkpoints[_.get(this.$route,'params.id',0)];
            },

            startTimeOptions:function(){
                // if(this.currentRace.id == 1){
                    return [
                        { "value":"04h00m", "text":"04:00 - Individual"},
                        { "value":"04h15m", "text":"04:15 - Revezamento"},
                        { "value":"05h00m", "text":"04:45 - Revezamento"},
                    ];
                // }else{
                //     return [
                //         { "value":"07h30m", "text":"07:00"}
                //     ]
                // }
            }
        },

        watch:{
            '$route':function(to,from){
                    var id = _.get(to,'params.id',0);
                    this.$store.commit('trechoIndex',id);
                    vtl.mapBase.percurso.showTrecho(id);
            }
        },

        mounted(){

        },


        methods:{

            convInMinutos:function(val){
                if(!val) return 0;
                var arrm = val.match(/(\d+)h(\d+)m/);
                if(arrm != null){
                    return parseInt(arrm[1]*60,10) + parseInt(arrm[2],10);
                }else{
                    return 0;
                }
            },


            calcula:function(){

                         var total = 0;
          var distTotal = 0;
          var minLargada = this.convInMinutos($('#hor-largada').val());
          

          var _this = this
          $('.trecho-ritmo').each(function(event) {
              //converto o valores para o tempo real
              var val = $(this).val();
              var arrm = val.match(/(\d+)h(\d+)m/);

              if(arrm != null){
                
                  var minutosTotal = parseInt(arrm[1]*60,10) + parseInt(arrm[2],10);


                 var dist = $(this).data("dist");
                 distTotal += dist;
                 //vejo se esse ta no limite
                 var pacePista = minutosTotal/dist;

                 // if(pacePista > 6.3){
                 //   $(this).parents(".ritmo").find(".info").text("Ritmo de "+pacePista.toFixed(2)+" min/km muito lento.").css("color","red");
                 // }else{
                 //    $(this).parents(".ritmo").find(".info").text("Ritmo de "+pacePista.toFixed(2)+" min/km").css("color","yellow");
                 // }

                 // var minAbertura = this.convInMinutos( $(this).data("abertura"));
                 var minFechamento = _this.convInMinutos( $(this).data("fechamento"));

                 if((total+minLargada)<minLargada){
                     $(this).parents(".ritmo").find(".info").text("Ritmo de "+pacePista.toFixed(2)+" fica fora do Horário de Abertura").css("color","red");
                 }else
                 if((total+minLargada+minutosTotal)>minFechamento){
                       $(this).parents(".ritmo").find(".info").text("Ritmo de "+pacePista.toFixed(2)+" fica fora do Horário de Fechamento").css("color","red");
                 }else{
                       $(this).parents(".ritmo").find(".info").text("Ritmo de "+pacePista.toFixed(2)+" min/km").css("color","yellow");
                 }

                  total += minutosTotal;


              }else{
                     $(this).parents(".ritmo").find(".info").text("");
              }
          });

          $("#tempototal").text( Math.floor(total/60)+"h "+(total % 60)+"m");
          $("#pacemedio").text( (total/distTotal).toFixed(1)+" min/h");

            }


        }


    }
    
</script>





<style lang="stylus" scoped>
    @import "./../css/variaveis"

    .trecho-info{

            .descripition{
                    b,strong{
                        color lighten(color-orange,40%)
                    }
            }

    }
    
       
        .slide-enter-to, .slide-leave{ 
               transform: translateX(10px);
               opacity: 0.5;
                transition: all .6s ease;
        }
         .slide-enter, .slide-leave-to{
               transform: translateX(10px);
               opacity: 0;
               transition: all .6s ease;
        }


    .navegationTrechos{

        a{
            cursor: pointer;
            display:inline-block;
            background rgba(black,0.5);
            padding:1em 2em;
        }
        
    }


    .info{
        font-size:12px;
        font-weight bolder;
        margin-left:2em;
        }

</style>